"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var import_drives_html_1 = __importDefault(require("./import-drives.html"));
var import_drives_controller_1 = __importDefault(require("./import-drives.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.settings.importdrives", {
        url: "/import-drives",
        controller: import_drives_controller_1.default,
        controllerAs: "vm",
        template: import_drives_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.settings.importdrives", [])
    .config(config)
    .controller("AdminImportDrivesController", import_drives_controller_1.default);
